var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from '../../helpers/Api';
import CollaboratorPacket from './Model';
var CollaboratorPacketStore = /** @class */ (function () {
    function CollaboratorPacketStore() {
        var _this = this;
        this.datas = [];
        this.loading = false;
        this.setData = function (data) {
            _this.loading = false;
            _this.data = data ? new CollaboratorPacket(data) : null;
            return _this.data;
        };
        this.setDatas = function (items) {
            _this.loading = false;
            _this.datas = items.filter(function (item) { return !item.disabled_at; }).map(function (item) { return new CollaboratorPacket(item); });
            return _this.datas;
        };
    }
    CollaboratorPacketStore.prototype.read = function (value) {
        this.loading = true;
        if (value) {
            return api.post("collaborators/packets/operator", value)
                .then(this.setData);
        }
        return api.get("collaborators/packets").then(this.setDatas);
    };
    CollaboratorPacketStore.prototype.updatePacketTIN = function (tin, row_id, packet_id, operator_id) {
        console.log('tin', tin);
        console.log('row_id', row_id);
        console.log('packet_id', packet_id);
        console.log('operator_id', operator_id);
        this.loading = true;
        var data = {
            tin: tin,
            row_id: row_id,
            packet_id: packet_id,
            operator_id: operator_id
        };
        return api.put("collaborators/packets/operator", data).then(this.setData);
    };
    __decorate([
        observable
    ], CollaboratorPacketStore.prototype, "data", void 0);
    __decorate([
        observable
    ], CollaboratorPacketStore.prototype, "datas", void 0);
    __decorate([
        observable
    ], CollaboratorPacketStore.prototype, "loading", void 0);
    __decorate([
        action
    ], CollaboratorPacketStore.prototype, "updatePacketTIN", null);
    __decorate([
        action
    ], CollaboratorPacketStore.prototype, "setData", void 0);
    __decorate([
        action
    ], CollaboratorPacketStore.prototype, "setDatas", void 0);
    return CollaboratorPacketStore;
}());
export default CollaboratorPacketStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorPackets/Store.ts
// module id = 739
// module chunks = 0